export const ORGANIZATION_URL_PLACEHOLDER = '$organizationUrl'
